import static_keys from './en/static'
import map from './en/map'
import survey from './en/survey'
import chart_titles from './en/chart_titles'

const en = Object.assign({}, static_keys, map, survey, chart_titles)

export default en
